module.exports = __webpack_public_path__ + "img/select-arrow.12752ffa.svg";